import React, { Component } from "react";
import { Link } from 'react-router-dom';

export default class PageFooter extends Component {
	
	constructor(){
		super()
		this.state = {
			height:0,
		}
		this.handleResize = this.handleResize.bind(this);
	}
    
    handleResize() {  
	    if (document.getElementsByClassName('c-page__footer').length > 0) {
	    	this.setState({height : document.getElementsByClassName('c-page__footer')[0].clientHeight});
		}
    }
    
	componentDidMount() {
    	window.addEventListener('resize', this.handleResize);
    	this.handleResize();
    }
    
	componentWillUnmount() {
    	window.removeEventListener('resize', this.handleResize);
    }
  	
	render () {
		
		const post = this.props.post
		
		if (document.getElementsByClassName('c-page').length > 0) {
			document.getElementsByClassName('c-page')[0].style.marginBottom = this.state.height + 'px';
		}
		
		if (post) {
						
		    return (
			    
			    <div className="c-page__footer">
			    	<div className="c-page__footer__inner">
				    	<div className="l-content">
				    		<div className="l-grid">
				    			<div className="l-grid__col l-grid__col--l-6-12">
				    				<ul className="c-page__footer__icons">
				    					{post.instagram_url &&
					    					<li className="c-page__footer__icons__item">
					    						<a href={post.instagram_url} target="_blank" className="c-page__footer__icons__link">
													<svg viewBox="0 0 40 40">
														<path d="m20 0c-11.03 0-20 8.97-20 20s8.97 20 20 20 20-8.97 20-20-8.97-20-20-20zm0 37.98c-9.92 0-17.98-8.07-17.98-17.98 0-9.92 8.07-17.98 17.98-17.98s17.98 8.06 17.98 17.98-8.06 17.98-17.98 17.98zm10.19-24.99c-0.55-1.45-1.7-2.59-3.14-3.15-0.83-0.31-1.71-0.48-2.6-0.5-1.14-0.05-1.51-0.06-4.41-0.06l-0.04 0.05c-2.9 0-3.27 0-4.41 0.06-0.89 0.02-1.77 0.19-2.6 0.5-1.45 0.55-2.59 1.7-3.15 3.15-0.31 0.83-0.48 1.71-0.5 2.6-0.05 1.14-0.06 1.51-0.06 4.41s0 3.27 0.06 4.41c0.04 0.88 0.22 1.74 0.54 2.56 0.55 1.45 1.7 2.59 3.15 3.15 0.83 0.31 1.71 0.48 2.6 0.5 1.14 0.05 1.51 0.06 4.41 0.06s3.27 0 4.41-0.06c0.89-0.02 1.77-0.19 2.6-0.5 1.45-0.55 2.59-1.7 3.14-3.15 0.31-0.83 0.48-1.71 0.5-2.6 0.05-1.14 0.06-1.5 0.06-4.41 0-2.9 0-3.27-0.06-4.41-0.02-0.9-0.19-1.77-0.5-2.61zm-1.49 11.34c-0.01 0.68-0.13 1.35-0.37 1.99-0.36 0.93-1.1 1.67-2.03 2.03-0.64 0.24-1.31 0.36-1.99 0.37-1.13 0.05-1.47 0.06-4.32 0.06-2.86 0-3.19 0-4.32-0.06-0.68-0.01-1.35-0.13-1.99-0.37-0.92-0.37-1.65-1.1-2-2.03-0.24-0.64-0.36-1.31-0.37-1.99-0.05-1.13-0.06-1.47-0.06-4.32s0-3.19 0.06-4.32c0.01-0.68 0.13-1.35 0.37-1.99 0.36-0.92 1.09-1.64 2-2 0.64-0.24 1.31-0.36 1.99-0.37 1.13-0.05 1.47-0.06 4.32-0.06v-0.02c2.85 0 3.19 0 4.32 0.06 0.68 0.01 1.35 0.13 1.99 0.37 0.93 0.36 1.66 1.1 2.03 2.03 0.24 0.64 0.36 1.31 0.37 1.99 0.05 1.13 0.06 1.47 0.06 4.32 0.01 2.84 0.01 3.18-0.06 4.31zm-8.7-9.82c-3.03 0-5.49 2.46-5.49 5.49s2.46 5.49 5.49 5.49 5.49-2.46 5.49-5.49-2.46-5.49-5.49-5.49zm0 9.05c-1.97 0-3.56-1.6-3.56-3.56 0-1.97 1.6-3.56 3.56-3.56 1.97 0 3.56 1.6 3.56 3.56 0 1.97-1.59 3.56-3.56 3.56zm5.71-10.55c-0.71 0-1.28 0.58-1.28 1.28 0 0.71 0.57 1.28 1.28 1.28s1.28-0.57 1.28-1.28-0.57-1.28-1.28-1.28z" fill="#fff"/>
													</svg>
					    						</a>
					    					</li>
				    					}
				    					{post.linkedin_url &&
					    					<li className="c-page__footer__icons__item">
					    						<a href={post.linkedin_url} target="_blank" className="c-page__footer__icons__link">
													<svg viewBox="0 0 40 40">
														<path d="m20 0c-11.03 0-20 8.97-20 20s8.97 20 20 20 20-8.97 20-20-8.97-20-20-20zm0 37.98c-9.92 0-17.98-8.07-17.98-17.98 0-9.92 8.07-17.98 17.98-17.98 9.92 0 17.98 8.07 17.98 17.98 0 9.92-8.06 17.98-17.98 17.98zm-8.2-28.72c-1.42 0-2.57 1.15-2.57 2.57s1.15 2.57 2.57 2.57 2.57-1.15 2.57-2.57-1.15-2.57-2.57-2.57zm-2.22 21.34h4.43v-14.26h-4.43v14.26zm15.74-14.61c-1.71-0.06-3.33 0.82-4.19 2.3h-0.08v-1.95h-4.25l0.02 14.26h4.43v-7.05c0-1.86 0.39-3.66 2.66-3.66s2.3 2.13 2.3 3.78v6.93h4.43v-7.82c-0.01-3.84-0.83-6.79-5.32-6.79z" fill="#fff"/>
													</svg>
					    						</a>
					    					</li>
				    					}
				    					{post.youtube_url &&
					    					<li className="c-page__footer__icons__item">
					    						<a href={post.youtube_url} target="_blank" className="c-page__footer__icons__link">
													<svg viewBox="0 0 40 40">
														<path d="m20 0c-11.03 0-20 8.97-20 20s8.97 20 20 20 20-8.97 20-20-8.97-20-20-20zm0 37.98c-9.92 0-17.98-8.07-17.98-17.98 0-9.92 8.07-17.98 17.98-17.98 9.92 0 17.98 8.07 17.98 17.98 0 9.92-8.06 17.98-17.98 17.98zm7.64-25.3h-15.28c-1.69 0-3.05 1.37-3.06 3.05v8.54c0.01 1.69 1.37 3.05 3.06 3.06h15.28c1.69-0.01 3.05-1.37 3.06-3.06v-8.54c-0.01-1.68-1.38-3.05-3.06-3.05zm-9.85 9.93v-5.99l5.78 2.99-5.78 3z" fill="#fff"/>
													</svg>
					    						</a>
					    					</li>
				    					}
				    				</ul>
								</div>
								<div className="l-grid__col l-grid__col--l-6-12">
									<div className="scope-footer-text" dangerouslySetInnerHTML={{__html:post.footer_address}}></div>
								</div>
								<div className="l-grid__col l-grid__col--l-6-12">
									<div className="scope-footer-text scope-footer-text--small c-disclaimer">
										<Link to={{ pathname: post.disclaimer_url }}>Disclaimer</Link>
									</div>
								</div>
								<div className="l-grid__col l-grid__col--l-6-12">
									<div className="scope-footer-text scope-footer-text--small">
										<Link to={{ pathname: post.privacy_policy_url }}>Privacy Policy</Link>
									</div>
								</div>
				    		</div>
				    	</div>
				    </div>
			    </div>
			    
			)
		
		} else {
			
			return null;
		}
	}
			
}
